import styled from 'styled-components'
import { devices } from '../../../globalStyle'

export const FilterDiv = styled.div<{ $active?: boolean }>`
  display: flex;
  width: 7vw;
  border: 1.6px solid ${({ $active }) => ($active ? '#0077b3' : '#0090d3')};
  background-color: ${({ $active }) => ($active ? '#eef6fb' : '#fff')};
  border-radius: 1.5vw;
  align-items: center;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    width: 5vw;
    height: 4vh;
  }
`

export const FilterImg = styled.img`
  margin-left: 0.7vw;
  height: 4vh;

  @media ${devices.largeDesktop} {
    margin-left: 0.4vw;
    height: 3vh;
  }
`

export const FilterText = styled.h2`
  margin-left: 0.3vw;
  font-size: 0.95vw;
  color: #0090d3;

  @media ${devices.largeDesktop} {
    margin-left: 0.2vw;
    font-size: 0.75vw;
  }
`
